import React from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";

import { Constants } from "../../../../../config/constants";
import useFirebase from "../../../../../config/context/firebaseContext";
import { GreyPallet } from "../../../../../config/styles";
import useBus from "../../context";

import MainText from "../../../../../components/MainText";
import { StyledChip } from "../../../../../components/StyledComponents";
import ModalNextBuses from "../ModalNextBuses";

import { BusStopListIdsType } from "../../../../../types/bus";

export type NextBusesRequiredProps = {
  stopIndex: BusStopListIdsType | undefined;
  nextTime: string;
  busId: string;
  timeNow: Date;
};

export default function FavoriteStop() {
  const { currentClock, activeStop, setActiveStop, nextBusesOnStop, busSchedules } = useBus();

  const { analyticLog, analyticSetProperties } = useFirebase();

  const [showModalNextBuses, setShowModalNextBuses] = React.useState<
    NextBusesRequiredProps | false
  >(false);

  const handleChangeBusStop = (event: SelectChangeEvent) => {
    const eventBusId = event.target.value as BusStopListIdsType;

    if (Object.keys(Constants.busStopListMap).includes(eventBusId)) {
      setActiveStop(eventBusId);

      analyticSetProperties("favorite_stop", eventBusId);

      analyticLog("select_favorite_stop", { stop: eventBusId });
    }
  };

  return (
    <>
      {showModalNextBuses ? (
        <ModalNextBuses data={showModalNextBuses} onClose={() => setShowModalNextBuses(false)} />
      ) : null}

      <FormControl
        fullWidth
        sx={{
          "& .MuiFormLabel-root": {
            fontWeight: "bold",
            color: `${GreyPallet.Regular} !important`,
          },
        }}
      >
        <InputLabel id="demo-simple-select-label" shrink={true}>
          Parada Favorita
        </InputLabel>
        <Select
          notched={true}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={String(activeStop || "")}
          label="Parada Favorita"
          onChange={handleChangeBusStop}
          sx={{
            borderRadius: "15px",

            height: 60,
            fontWeight: "bold",
            fontSize: 16,
            color: GreyPallet.Regular,

            "& .MuiSvgIcon-root": {
              fontSize: 40,
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderWidth: "3px !important",
              borderColor: `${GreyPallet.Light} !important`,
              borderStyle: "solid",
              "& .Mui-focused": {
                borderColor: `${GreyPallet.Regular} !important`,
              },
            },
          }}
          IconComponent={KeyboardArrowDownIcon}
        >
          <MenuItem value={""} disabled>
            Parada Favorita
          </MenuItem>
          {Object.keys(Constants.busStopListMap).map((stopId) => (
            <MenuItem key={stopId} value={stopId}>
              {Constants.busStopListMap[stopId as BusStopListIdsType].name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {
        <MainText size="tiny" color="regular">
          * O ônibus chegará na parada escolhida em:
        </MainText>
      }

      <Box mt={2} mb={5} sx={{ w: "100%" }}>
        <Box style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {nextBusesOnStop.map((item) => (
            <StyledChip
              key={item.busId}
              chipcolor={busSchedules?.[item?.busId]?.color}
              label={`${busSchedules?.[item?.busId]?.shortName} ${Math.round(item?.next)}min`}
              onClick={() => {
                setShowModalNextBuses({
                  timeNow: currentClock,
                  busId: item.busId,
                  nextTime: String(item.next),
                  stopIndex: activeStop,
                });
              }}
            />
          ))}
        </Box>
      </Box>
    </>
  );
}
